import { push } from 'connected-react-router';
import { call, put, select, takeLatest, fork, delay } from 'redux-saga/effects';

import { fetchBuilderSuccess } from '../actions';
import ProgressAPI from '../api/ProgressAPI';
import { BUILDER_CONTINUE_LATEST } from '../constants/actionTypes';
import { APP_RELOAD_SUCCESS_HEAP, APP_RELOAD_ERROR_HEAP } from '../constants/heapEvents';
import { track } from '../lib/heapHelpers';
import {
  accessTokenSelector,
  customerGuidSelector,
  wizardNextStepSelector,
} from '../reducers/selectors';

import { errorStatus, manageAPIError } from './helpers/errorHelper';

function* progressContinueWatcher() {
  yield takeLatest(BUILDER_CONTINUE_LATEST, progressContinueWorker);
}

function* fetchBuilderResource(customerGuid, accessToken, action) {
  try {
    const builder = yield call(ProgressAPI.fetchLatestUnsubmitedFor, customerGuid, accessToken);
    yield put(fetchBuilderSuccess(builder));
  } catch (err) {
    yield call(track, APP_RELOAD_ERROR_HEAP, { customerGuid });

    const status = errorStatus(err);

    if (status !== 404) {
      yield fork(manageAPIError, { ...err, action });
    }
  }
}

function* progressContinueWorker(action) {
  let customerGuid = '';

  try {
    const accessToken = yield select(accessTokenSelector);
    customerGuid = yield select(customerGuidSelector);
    yield fork(fetchBuilderResource, customerGuid, accessToken);
    yield delay(process.env.REACT_APP_FETCH_HALT_TIME);
    const newUrl = yield select(wizardNextStepSelector);
    yield put(push(newUrl));
    yield call(track, APP_RELOAD_SUCCESS_HEAP, { customerGuid });
  } catch (err) {
    yield fork(manageAPIError, { ...err, action });
    yield call(track, APP_RELOAD_ERROR_HEAP, { customerGuid });
  }
}

export { progressContinueWorker, fetchBuilderResource };
export default progressContinueWatcher;
